import { t } from "@lingui/macro";

export type EventSignUpAccess =
  | "CLOSED"
  | "COMPLETE"
  | "DRAFT"
  | "FULL"
  | "PENDING"
  | "SIGNUP_AVAILABLE"
  | "WAITLIST_AVAILABLE"
  | null;

export const normalizeEventStatus = (
  status?: EventSignUpAccess,
  short?: boolean
) => {
  switch (status) {
    case "CLOSED":
      return short ? t`Closed` : t`Signup Closed`;
    case "COMPLETE":
      return t`Complete`;
    case "DRAFT":
      return t`Draft`;
    case "FULL":
      return t`Full`;
    case "PENDING":
      return short ? t`Pending` : t`Signup Pending`;
    case "SIGNUP_AVAILABLE":
      return short ? `Open` : t`Signup Open`;
    case "WAITLIST_AVAILABLE":
      return short ? `Waitlist` : t`Waitlist Open`;
    default:
      return t`Draft`;
  }
};
